import { useEffect, useState } from "react";
import Layout from "./Layout";
import {
  fetch_heads_data,
  server_post_data,
  update_point_status,
} from "../ServiceConnection/serviceconnection.js";
import {
  handleError,
  handleSuccessShow,
} from "../CommonJquery/CommonJquery.js";
import Loader from "./Loader.js";

const LiveUpdates = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [alertForm, setAlertForm] = useState({ message: "" });
  const [headsData, setHeadsData] = useState({
    Parking: [
      "Main Parking",
      "VIP Parking",
      "Bus Parking",
      "Two Wheeler Parking",
    ],
    Ghat: [
      "Dashashwamedh Ghat",
      "Manikarnika Ghat",
      "Assi Ghat",
      "Harishchandra Ghat",
    ],
    Temple: [
      "Kashi Vishwanath",
      "Sankat Mochan",
      "Durga Temple",
      "Tulsi Manas",
    ],
    Medical: [
      "Main Medical Center",
      "Emergency Ward",
      "Pharmacy",
      "First Aid Post",
    ],
    "Food Court": [
      "Main Food Court",
      "Prasad Counter",
      "Snacks Corner",
      "Water Station",
    ],
  });

  const [liveUpdatesForm, setLiveUpdatesForm] = useState({
    head: "",
    name: "",
    status: "",
  });

  const handleSubmitAlert = (e) => {
    e.preventDefault();

    setAlertForm({ message: "" });
    alert("Alert published successfully!");
  };

  const handleSubmitLiveUpdates = (e) => {
    e.preventDefault();
   

    setLiveUpdatesForm({ head: "", name: "", status: "Open" });
    alert("Live update published successfully!");
  };

  const master_data_get = async () => {
    setIsLoading(true);
    let fd = new FormData();

    await server_post_data(fetch_heads_data, fd)
      .then((Response) => {
        if (Response.data.error) {
          setIsLoading(false);
          handleError(Response.data.message);
        } else {
          setHeadsData(Response.data.data);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    master_data_get();
  }, []);

  const handleSubmitUpdate = async (e) => {
    setIsLoading(true);
    e.preventDefault();
    let fd = new FormData();
    fd.append("primary_id", liveUpdatesForm.name);
    fd.append("status", liveUpdatesForm.status);

    await server_post_data(update_point_status, fd)
      .then((Response) => {
        if (Response.data.error) {
          setIsLoading(false);
          handleError(Response.data.message);
        } else {
          handleSuccessShow(Response.data.message);
          setIsLoading(false);
          setLiveUpdatesForm({
            head: "",
            name: "",
            status: "",
          });
        }
      })
      .catch((error) => {
        setIsLoading(false);
      });
  };

  return (
    <>
      {isLoading && <Loader />}
      <Layout>
        <div className="page">
          <h2 className="page-title">Update Point's Live Status</h2>
          <div className="tabs-container">
            <div className="tab-content">
              <div className="forms-grid">
                {/* Live Updates Form */}
                <div className="form-card">
                  <h3 className="form-title">Live Updates</h3>
                  <form onSubmit={handleSubmitLiveUpdates}>
                    <div className="form-group">
                      <label className="label">Select Point Type:</label>
                      <select
                        className="select"
                        value={liveUpdatesForm.head}
                        onChange={(e) =>
                          setLiveUpdatesForm({
                            ...liveUpdatesForm,
                            head: e.target.value,
                            name: "", // reset name when head changes
                          })
                        }
                        required
                      >
                        <option value="">Select Type</option>
                        {Object.keys(headsData).map((head, index) => (
                          <option key={index} value={head}>
                            {head}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="form-group">
                      <label className="label">Point:</label>
                      <select
                        className="select"
                        value={liveUpdatesForm.name}
                        onChange={(e) => {
                          const selectedPoint = headsData[
                            liveUpdatesForm.head
                          ]?.find(
                            (point) =>
                              point.primary_id === parseInt(e.target.value)
                          );
                          console.log(selectedPoint);
                          setLiveUpdatesForm({
                            ...liveUpdatesForm,
                            name: selectedPoint?.primary_id,
                            status: selectedPoint?.status,
                          });
                          console.log(liveUpdatesForm);
                        }}
                        required
                        disabled={!liveUpdatesForm.head}
                      >
                        <option value="" disabled hidden>
                          Select Point
                        </option>
                        {liveUpdatesForm.head &&
                          headsData[liveUpdatesForm.head]?.map((point) => (
                            <option
                              key={point.primary_id}
                              value={point.primary_id}
                            >
                              {point.name}
                            </option>
                          ))}
                      </select>
                    </div>

                    <div className="form-group">
                      <label className="label">Status:</label>
                      <select
                        className="select"
                        value={liveUpdatesForm.status}
                        onChange={(e) =>
                          setLiveUpdatesForm({
                            ...liveUpdatesForm,
                            status: e.target.value,
                          })
                        }
                      >
                        <option value="0">Open</option>
                        <option value="1">Closed</option>
                        <option value="2">Under Maintenance</option>
                      </select>
                    </div>

                    <button
                      type="submit"
                      className="submit-button"
                      onClick={handleSubmitUpdate}
                    >
                      Update Status
                    </button>
                  </form>
                </div>

                {/* General Alert Form */}
                <div
                  className="form-card"
                  style={{ opacity: 0, pointerEvents: "none" }}
                >
                  <h3 className="form-title">General Alert</h3>
                  <form onSubmit={handleSubmitAlert}>
                    <div className="form-group">
                      <label className="label">Alert Message:</label>
                      <textarea
                        className="textarea"
                        placeholder="Enter alert message for pilgrims..."
                        value={alertForm.message}
                        onChange={(e) =>
                          setAlertForm({
                            ...alertForm,
                            message: e.target.value,
                          })
                        }
                        required
                      />
                    </div>
                    <button type="submit" className="submit-button">
                      Publish Alert
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
};

export default LiveUpdates;
